
export const badge = {
    success: "bg-green",
    pending: "bg-pending",
    failed: "bg-red",
    rejected: "bg-red",
    freeze: "bg-pending",
    consume: "bg-consume",
    fail: "bg-red",
    inactive: "bg-red",
    active: "bg-green",
    cancel: "bg-red",
    kycrejected: "bg-red",
    kycpending: "bg-pending",
    cancelled: "bg-red",
    unFreeze: "bg-freeze",
    suspended: "bg-red",
    submitted: "bg-submitted",
    "freeze pending": "bg-pending",
    "unfreeze pending": "bg-unfreezPending",
    "bg-unfreezPending": "bg-pending",
    approved: "bg-green",
    reopened: "bg-pending",
  };
 